<template>
  <div class="chapter chapter6">
    <video autoplay muted loop id="redVideo" :src="video">
    </video>
    <div v-if="slide === 1" class="red-container">
      <Header v-bind:currentTimer="currentTimer" v-bind:strikes="collectedStrikes" :key="headerKey" styleType="red" hideLogo="false" hideTimer="true" />
      <div class="content-container">
        <div class="container h-100 pt-5">
          <div class="row justify-content-center">
            <div class="col-8">
              <h4 v-html="$t('chapter6.slide1.intro')"></h4>
              <table class="table table-dark table-striped table-hover table-sm">
                <thead>
                  <tr>
                    <th scope="col">Team</th>
                    <th scope="col">{{ $t('chapter6.slide1.players') }}</th>
                    <th scope="col">{{ $t('chapter6.slide1.score') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(entry, index) in gameScore">
                    <tr :key="index" v-if="entry.teamname === $store.state.teamname" :class="[(entry.teamname === $store.state.teamname ? 'bg-danger' : '')]">
                      <td>{{ entry.teamname }}</td>
                      <td>{{ entry.players }}</td>
                      <td>{{ entry.points }}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-8 pt-5 text-center">
              <h4 v-html="$t('chapter6.slide1.outro')"></h4>
            </div>
          </div>
        </div>
      </div>
      <Footer type="red" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import axios from 'axios'

export default {
  name: 'Chapter6',
  components: {
    Header, Footer
  },
  data: function () {
    return {
      pw: 'asdkfjhtmnbvasdfknedsfDSF',
      chapter: 6,
      slide: 1,
      gameScore: null
    }
  },
  computed: {
    video: function () {
      return 'https://tabbot-central.b-cdn.net/video/papstBG.mp4'
    }
  },
  methods: {
    getGameScore: function () {
      axios.get('http://admin.tabbot-central.com/getGameScore.php', {
        params: {
          token: this.pw
        }
      }).then(response => {
        console.log(response)
        this.gameScore = response.data
      }).catch(error => {
        console.log(error)
        setTimeout(this.getGameScore, 5000)
      })
    }
  },
  created: function () {
    this.getGameScore()
  }
}
</script>
